exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carousel-inner.onebyone-carosel { margin: auto; width: 90%; }\n.onebyone-carosel .active.left { left: -33.33%; }\n.onebyone-carosel .active.right { left: 33.33%; }\n.onebyone-carosel .next { left: 33.33%; }\n.onebyone-carosel .prev { left: -33.33%; }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /workspace/backend-server/src/app/layout/slider/slider.component.css
// module id = ../../../../../src/app/layout/slider/slider.component.css
// module chunks = main